export * from './lib/chip.component.module';
